<template>
  <div class="order-payments_items">
    <el-row
      type="flex"
      :gutter="20"
      class="order-payments_row">
      <el-col
        :sm="8"
        :xs="24">
        <div
          :class="{active: getIsInnerPaymentSelected}"
          class="order-payments-item"
          @click="setPaymentInner">
          <div class="order-payments-item_name">{{ getInnerPayment.name }}</div>
          <div class="order-payments-item_description">{{ getInnerPayment.description }}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'PaymentInner',
    computed: {
      ...mapGetters('order', [
        'getInnerPayment',
        'getIsInnerPaymentSelected'
      ])
    },
    methods: {
      ...mapActions('order', [
        'setPaymentInner'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/PaymentInner.vue